import FileQuestionIcon from "@uui/FileQuestion03";
import { isEmpty } from "lodash/fp";

import TableCell from "@app/analytics/components/Table/TableCell";
import TableRow from "@app/analytics/components/Table/TableRow";
import useReportsTable from "@app/analytics/MeetingReports/stores/reportsTable";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";

const IncompleteMeetingReportsEmptyState = () => {
  const hasAppliedFilters = useReportsTable(
    (state) =>
      !isEmpty(state.sources.selected) &&
      state.sources.selected.length < state.sources.all.length
  );

  return (
    <TableRow>
      <TableCell colSpan={100}>
        <EmptyStateContainer sx={{ height: "440px" }}>
          <EmptyStateIcon Icon={FileQuestionIcon} />
          {hasAppliedFilters ? (
            <>
              <EmptyStateTitle>No Reports</EmptyStateTitle>
              <EmptyStateSubtext>
                Remove filters to see your reports.
              </EmptyStateSubtext>
            </>
          ) : (
            <>
              <EmptyStateTitle>All clear</EmptyStateTitle>
              <EmptyStateSubtext>
                Good news! All of your meeting reports were processed as
                expected.
              </EmptyStateSubtext>
              <Button variant="gradient" component={Link} to={ROUTES.REPORTS}>
                View my meetings
              </Button>
            </>
          )}
        </EmptyStateContainer>
      </TableCell>
    </TableRow>
  );
};

export default IncompleteMeetingReportsEmptyState;
